function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Movie = function Movie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M8.54 9.168q.213.277.471.512h-.868q.223-.236.396-.512M8.084 5.1a3.28 3.28 0 0 0-2.335-.97c-1.82 0-3.29 1.47-3.29 3.29 0 .876.343 1.671.9 2.26h-.34c-.96 0-1.75.79-1.75 1.75v8c0 .96.79 1.75 1.75 1.75h14c.96 0 1.75-.79 1.75-1.75v-.748l2.98.948c.08.03.15.04.23.04v.01c.15 0 .31-.05.44-.14.2-.15.31-.37.31-.61v-6.98c0-.24-.12-.47-.31-.61a.76.76 0 0 0-.67-.11l-2.98.948v-.748c0-.96-.79-1.75-1.75-1.75h-2.691a3.94 3.94 0 0 0 1.291-2.92c0-2.18-1.77-3.95-3.95-3.95A3.95 3.95 0 0 0 8.085 5.1m3.585-.78c-1.35 0-2.45 1.1-2.45 2.45s1.1 2.45 2.45 2.45 2.45-1.1 2.45-2.45-1.1-2.45-2.45-2.45m7.1 9.43v3.36l2.46.78v-4.92zm-1.5-.55v-1.77c0-.14-.11-.25-.25-.25h-14c-.14 0-.25.11-.25.25v8c0 .14.11.25.25.25h14c.14 0 .25-.11.25-.25V13.2M3.96 7.43c0-.99.8-1.79 1.79-1.79s1.79.8 1.79 1.79-.8 1.79-1.79 1.79-1.79-.8-1.79-1.79",
    clipRule: "evenodd"
  }));
};
export default Movie;
Movie.displayName = 'Movie';